import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { clearSuccessMessage, clearErrorMessage } from '../redux/edit-mode'
import Notifications from '../components/notifications'

const NotificationsContainer = connect(
    ({ editMode: { error, success } }) => ({ error, success }),
    dispatch => bindActionCreators({ clearSuccessMessage, clearErrorMessage }, dispatch),
)(Notifications)
export default NotificationsContainer
